<nz-card class="em-area">
  <nz-skeleton
    [nzActive]="true"
    [nzLoading]="(loading$ | async) ?? false"
    [nzParagraph]="{ rows: 1 }"
  >
    <nz-descriptions class="em-area" nzLayout="vertical">
      <nz-descriptions-item
        *ngIf="notificationError$ | async as errorMsg; else notificationResult"
        nzTitle="Element status"
      >
        <em-error-result [subTitle]="errorMsg"></em-error-result>
      </nz-descriptions-item>

      <ng-template #notificationResult>
        <ng-container *ngIf="notification$ | async as notification">
          <nz-descriptions-item nzTitle="Element status code">
            <em-display-property [value]="notification.elementStatus"></em-display-property>
          </nz-descriptions-item>
          <nz-descriptions-item nzTitle="Element status text">
            <em-display-property [value]="notification.elementStatusText"></em-display-property>
          </nz-descriptions-item>
        </ng-container>
      </ng-template>

      <nz-descriptions-item
        *ngIf="orderError$ | async as errorMsg; else orderResult"
        nzTitle="Element status"
      >
        <em-error-result [subTitle]="errorMsg"></em-error-result>
      </nz-descriptions-item>

      <ng-template #orderResult>
        <nz-descriptions-item nzTitle="Mould priority">
          <em-display-property
            [value]="(primaryOrder$ | async)?.priorityDescription ?? ''"
          ></em-display-property>
        </nz-descriptions-item>
      </ng-template>
    </nz-descriptions>
  </nz-skeleton>
</nz-card>
